module.exports = __webpack_public_path__ + "card/img/sharePic_share.9e29d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharePic_share.png
// module id = Hiao
// module chunks = 1